import { Button, Tag, Typography } from 'antd';
import { PAYOUT_REPORT_STATUS } from 'constants/status';
import { EyeOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import currencyFormat from 'utils/currencyFormat';

const columnStyles = {
  fontWeight: 700,
  fontSize: '14px',
  textAlign: 'center',
  width: '100%',
  whiteSpace: 'nowrap'
};

const textStyle = {
  fontSize: '14px',
  width: '100%'
};

const getRegularBasedPayoutReport = (handleViewDetails) => {
  /* eslint-disable camelcase */

  return [
    {
      title: <Typography.Text style={columnStyles}>Payout ID</Typography.Text>,
      dataIndex: 'payout_id',
      key: 'payout_id',
      width: 100,
      fixed: 'left',
      render: (payout_id) => {
        return <Typography.Text style={textStyle}>{payout_id}</Typography.Text>;
      }
    },
    {
      title: <Typography.Text style={columnStyles}>Reporting Duration</Typography.Text>,
      dataIndex: 'payout_month_report',
      key: 'payout_month_report',
      width: 120,
      render: (_, record) => {
        const payoutStartMonth = record?.payout_start_date;
        const payoutEndMonth = record?.payout_end_date;

        const startOfMonth = payoutStartMonth ? dayjs(payoutStartMonth).format('DD/MM/YYYY') : null;

        const endOfMonth = payoutEndMonth ? dayjs(payoutEndMonth).format('DD/MM/YYYY') : null;

        return (
          <Typography.Text style={textStyle}>
            {startOfMonth} - {endOfMonth}
          </Typography.Text>
        );
      }
    },
    {
      title: <Typography.Text style={columnStyles}>Commission (₹)</Typography.Text>,
      dataIndex: 'commission_amount',
      key: 'commission_amount',
      width: 90,
      render: (commission_amount) => {
        return (
          <Typography.Text style={textStyle}>
            {currencyFormat(commission_amount, true, true)}
          </Typography.Text>
        );
      }
    },
    {
      title: <Typography.Text style={columnStyles}>TDS (₹)</Typography.Text>,
      dataIndex: 'tds_amount',
      key: 'tds_amount',
      width: 90,
      render: (tds_amount) => {
        return (
          <Typography.Text style={textStyle}>
            {currencyFormat(tds_amount, true, true)}
          </Typography.Text>
        );
      }
    },
    {
      title: <Typography.Text style={columnStyles}>GST (₹)</Typography.Text>,
      dataIndex: 'gst_amount',
      key: 'gst_amount',
      width: 90,
      render: (gst_amount) => {
        return (
          <Typography.Text style={textStyle}>
            {currencyFormat(gst_amount, true, true)}
          </Typography.Text>
        );
      }
    },
    {
      title: <Typography.Text style={columnStyles}>Invoice (₹)</Typography.Text>,
      dataIndex: 'invoice_amount',
      key: 'invoice_amount',
      width: 100,
      render: (invoice_amount) => {
        return (
          <Typography.Text style={textStyle}>
            {currencyFormat(invoice_amount, true, true)}
          </Typography.Text>
        );
      }
    },
    {
      title: <Typography.Text style={columnStyles}>Status</Typography.Text>,
      dataIndex: 'status',
      key: 'status',
      width: 90,
      render: (status) => {
        return (
          <Typography.Text style={textStyle}>
            {' '}
            <Tag
              color={PAYOUT_REPORT_STATUS[status]?.bgColor}
              style={{
                padding: '2px 13px',
                color: PAYOUT_REPORT_STATUS[status]?.color
              }}
            >
              {PAYOUT_REPORT_STATUS[status]?.label}
            </Tag>
          </Typography.Text>
        );
      }
    },
    {
      title: <Typography.Text style={columnStyles}>Actions</Typography.Text>,
      align: 'center',
      width: 50,
      fixed: 'right',
      render: (r) => {
        return (
          <div>
            <Button
              size="medimum"
              style={{ borderColor: 'var(--color-primary)' }}
              icon={
                <EyeOutlined
                  style={{ color: 'var(--color-primary)' }}
                  onClick={() => handleViewDetails(r)}
                />
              }
            />
          </div>
        );
      }
    }
  ];
};

const RegularSearchArr = [
  {
    value: '_id',
    label: 'Payout ID'
  }
];

const RegularReportStatus = [
  {
    label: 'Invoice Pending',
    value: 'PARTNER_AWAITING'
  },
  {
    label: 'Hold',
    value: 'INVOICE_ON_HOLD'
  },
  {
    label: 'Paid',
    value: 'PAID'
  },
  {
    label: 'Advance Paid',
    value: 'ADVANCE_PAID'
  },
  {
    label: 'Processing',
    value: 'PROCESSING'
  }
];

const RegularPayoutReportfiltersArr = [
  {
    attr: 'status',
    label: 'Status',
    data: RegularReportStatus
  }
];

//  while invoice upload add the loading
export { getRegularBasedPayoutReport, RegularPayoutReportfiltersArr, RegularSearchArr };
